/**
 * Secure Store abstraction layer.
 * Decouples frontend components from direct localStorage / sessionStorage calls,
 * preparing the CruzFind platform for secure, HTTP-only, SameSite=Strict cookie structures.
 */

export const secureStore = {
  // Admin Vault Session Token
  getAdminAuthToken(): string | null {
    return sessionStorage.getItem('cf_admin_auth_token');
  },
  
  setAdminAuthToken(token: string): void {
    sessionStorage.setItem('cf_admin_auth_token', token);
  },
  
  clearAdminAuthToken(): void {
    sessionStorage.removeItem('cf_admin_auth_token');
  },

  // User Verification Token Signature
  getAuthTokenSignature(): string | null {
    return localStorage.getItem('cf_auth_token_signature');
  },
  
  setAuthTokenSignature(signature: string): void {
    localStorage.setItem('cf_auth_token_signature', signature);
  },
  
  clearAuthTokenSignature(): void {
    localStorage.removeItem('cf_auth_token_signature');
  },

  // Hardware Active Signature Key
  getHardwareActiveSignature(): string | null {
    return localStorage.getItem('cf_hw_active_signature');
  },
  
  setHardwareActiveSignature(signature: string): void {
    localStorage.setItem('cf_hw_active_signature', signature);
  },
  
  clearHardwareActiveSignature(): void {
    localStorage.removeItem('cf_hw_active_signature');
  }
};
